var ls = self.localStorage || {
    getItem: function () { },
    setItem: function () { }
}, msgLocalCache = ls ? "" : "不支持本地缓存";
if (msgLocalCache) {
    console.error ? console.error(msgLocalCache) : console.log(msgLocalCache);
}

export function localSet(key,value) {
    return ls.setItem(key,value);
}

export function localGet(key) {
    return ls.getItem(key);
}
